import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["idRegion"];
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { request } from "@/js/http/http_request";
import { scrollTo } from "@/js/animation";
import { isUserBuyerGroup, hasRole } from "@/js/http/auth";
import { ERROR_DATA, getErrorData, handleErrorData } from "@/js/forms.js";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import RegionFormModal from "@/components/region/RegionFormModal";
export default {
  name: "RegionList",
  components: {
    ErrorModal: ErrorModal,
    RegionFormModal: RegionFormModal
  },
  props: {
    loggedUserData: Object,
    type: String
  },
  data: function data() {
    return {
      countries: [],
      showRegion: null,
      imagesBroken: [],
      regionForm: {
        canManageRegions: false,
        editedId: null
      },
      ERROR_DATA: ERROR_DATA
    };
  },
  created: function created() {
    this.regionForm.canManageRegions = hasRole(process.env.VUE_APP_ROLES_MANAGE_APPELLATION);
  },
  mounted: function mounted() {
    this.getRegionsOfType();
  },
  methods: {
    getRegionsOfType: function getRegionsOfType() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2$$route;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.$EventBus.$emit("loading", true);
              _this = _this2;
              _context.next = 4;
              return request("/v1/countries/regions?type=".concat(_this2.type), "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get the list of regions");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context.sent;
              _this2.countries = response.data.countries;
              if ((_this2$$route = _this2.$route) !== null && _this2$$route !== void 0 && (_this2$$route = _this2$$route.query) !== null && _this2$$route !== void 0 && _this2$$route.idRegion) {
                _this2.$nextTick(function () {
                  scrollTo("#region-" + _this2.$route.query.idRegion);
                  var _this2$$route$query = _this2.$route.query,
                    idRegion = _this2$$route$query.idRegion,
                    newQueryParams = _objectWithoutProperties(_this2$$route$query, _excluded);
                  _this2.$router.replace({
                    query: newQueryParams
                  });
                });
              }
              _this2.$EventBus.$emit("loading", false);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    selectRegion: function selectRegion(idRegion) {
      var query = {
        idRegion: idRegion,
        type: this.type
      };
      if (isUserBuyerGroup(this.loggedUserData)) {
        return {
          name: "userRegionDetails",
          query: query
        };
      } else {
        return {
          name: "adminRegionDetails",
          query: query
        };
      }
    },
    startAddRegion: function startAddRegion() {
      var _this3 = this;
      this.regionForm.editedId = null;
      this.$nextTick(function () {
        _this3.$refs.regionForm.open();
      });
    },
    openEditRegion: function openEditRegion(regionId) {
      var _this4 = this;
      this.regionForm.editedId = regionId;
      this.$nextTick(function () {
        _this4.$refs.regionForm.open();
      });
    }
  },
  watch: {
    type: function type(newVal, oldVal) {
      this.getRegionsOfType();
    }
  }
};